export function getSelectedLabel(
  array,
  value,
  labelAttr,
  valueAttr,
  defaultLabel,
) {
  if (!array || array.length === 0) return defaultLabel || "";
  if (value === "" || !value) return defaultLabel || "";
  const item =
    array.find((item) => {
      if (item instanceof Object) {
        if (valueAttr instanceof Function) {
          return valueAttr(item) === value;
        } else {
          return item[valueAttr] === value;
        }
      } else {
        return item === value;
      }
    }) || "";
  if (item instanceof Object) {
    if (labelAttr instanceof Function) {
      return labelAttr(item);
    } else {
      return item[labelAttr];
    }
  } else {
    if (labelAttr instanceof Function) {
      return labelAttr(item);
    } else {
      return item;
    }
  }
}

export function getSelectedValue(array, value, valueAttr) {
  if (value === "") return null;
  const found = array.find((item) => {
    if (item instanceof Object) {
      if (valueAttr instanceof Function) {
        return valueAttr(item) === value;
      } else {
        return item[valueAttr]?.toString() === value;
      }
    } else {
      return item === value;
    }
  });
  return found;
}

export function getValueAtrr(item, valueAttr) {
  if (!item) return "";
  if (item instanceof Object) {
    if (valueAttr instanceof Function) {
      return valueAttr(item);
    } else {
      return item[valueAttr];
    }
  } else {
    return item;
  }
}

export function isChecked(item, value, valueAttr) {
  if (value instanceof Array && value.length === 0) return false;
  return (
    value
      .map((item) => (item instanceof Object && item[valueAttr]) || item)
      .indexOf(item) >= 0
  );
}

function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); // $& means the whole matched string
}

export async function searchOptions(
  array,
  search,
  value,
  labelAttr,
  valueAttr,
) {
  let items = [];
  if (!array?.length) return [];
  else if (!!labelAttr || !!valueAttr) {
    items = array.map((item, index) => {
      if (!(item instanceof Object))
        throw Error(
          "Invalid array supplied. All options must be of type Object",
        );
      const value =
        (!!valueAttr && item[valueAttr]) ||
        (Object.keys(item).length > 0 && item[Object.keys(item)[0]]) ||
        index;
      if (labelAttr instanceof Function) {
        const label = labelAttr(item);
        return { value, label };
      } else {
        const label =
          (!!labelAttr && item[labelAttr]) ||
          (Object.keys(item).length > 1 && item[Object.keys(item)[1]]) ||
          (Object.keys(item).length > 0 && item(Object.keys(item)[0])) ||
          JSON.stringify(item);
        return { value, label };
      }
    });
  } else {
    items = array.map((option) => {
      return {
        value: option,
        label: (labelAttr instanceof Function && labelAttr(option)) || option,
      };
    });
  }
  if (
    search !== "" &&
    search !== getSelectedLabel(array, value, labelAttr, valueAttr)
  ) {
    const regexp = new RegExp(
      `${escapeRegExp(search)
        .replace(" ", "\\s+")
        .replace(/[aA]/gi, "[aâàáäAÂÀÁÄ]")
        .replace(/[eE]/gi, "[eêèéëEÊÈÉË]")
        .replace(/[iI]/gi, "[iîìíïIÎÌÍÏ]")
        .replace(/[oO]/gi, "[oôòóöOÔÒÓÖ]")
        .replace(/[uU]/gi, "[uûùúüUÛÙÚÜ]")}`,
      "isu",
    );
    items = items.filter((option) => {
      return regexp.test(option.label);
    });
  }
  return Promise.resolve(items);
}

export function toSelectOptions(array, labelAttr, valueAttr) {
  let items = [];
  if (!array?.length) return [];
  else if (!!labelAttr || !!valueAttr) {
    items = array.map((item, index) => {
      if (!(item instanceof Object))
        throw Error(
          "Invalid array supplied. All options must be of type Object",
        );
      const value = !!valueAttr
        ? valueAttr instanceof Function
          ? valueAttr(item)
          : item[valueAttr]
        : (Object.keys(item).length > 0 && item[Object.keys(item)[0]]) || index;
      // (!!valueAttr && valueAttr instanceof Function && valueAttr(item) || item[valueAttr]) || (Object.keys(item).length > 0 && item[Object.keys(item)[0]]) || index;
      const label = !!labelAttr
        ? labelAttr instanceof Function
          ? labelAttr(item)
          : item[labelAttr]
        : (Object.keys(item).length > 1 && item[Object.keys(item)[1]]) ||
          (Object.keys(item).length > 0 && item(Object.keys(item)[0])) ||
          JSON.stringify(item);
      // if (labelAttr instanceof Function) {
      //   const label = labelAttr(item);
      //   return { value, label };
      // } else {
      //   const label =
      //     (!!labelAttr && item[labelAttr]) ||
      //     (Object.keys(item).length > 1 && item[Object.keys(item)[1]]) ||
      //     (Object.keys(item).length > 0 && item(Object.keys(item)[0])) ||
      //     JSON.stringify(item);
      //   return { value, label };
      // }
      return { value, label };
    });
  } else {
    items = array.map((option) => {
      return { value: option, label: option };
    });
  }
  return items;
}

export function adjustCoordinate(value, precision, scale) {
  if (!Number.isNaN(value)) {
    return Number.parseFloat(
      Number.parseFloat(value).toPrecision(precision),
    ).toFixed(scale);
  } else {
    return value;
  }
}
